import type { FormikHelpers } from 'formik';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import * as apiProduct from 'api/apiProducts';
import { deleteCloudflareFiles } from 'api/apiCloudflare';
import { useToast } from 'context/ToastContext';
import type { ProductEditType } from '../../types';
import ProductFormImagesList from './ProductFormImagesList';

interface ProductFormImagesProps {
    isSubmitting: boolean;
    setFieldValue: FormikHelpers<ProductEditType>['setFieldValue'];
    values: ProductEditType;
}

const ProductFormIamges = ({ setFieldValue, values }: ProductFormImagesProps) => {
    const { t } = useTranslation(['Products', 'common']);
    const { showToast } = useToast();

    const hasLegacyImages = !!values?.prodImages?.split(';')?.some((src) => src.trim() !== '');

    const saveProdImages = useCallback(
        async (nextProdImages: string): Promise<boolean> => {
            const productId = Number(values?.ID || 0);
            if (productId <= 0) return true;
            const stat = await apiProduct.saveImages(productId, nextProdImages);
            if (!stat) showToast(t('common:messError'), 'danger');
            return stat;
        },
        [showToast, t, values?.ID],
    );

    const handleDeleteImage = useCallback(
        async (src: string, nextProdImages: string): Promise<boolean> => {
            const productId = Number(values?.ID || 0);
            if (productId > 0) {
                await deleteCloudflareFiles({
                    publicUrls: [src],
                    scope: { productId },
                });
            }
            return saveProdImages(nextProdImages);
        },
        [saveProdImages, values?.ID],
    );

    if (!hasLegacyImages) return null;

    return (
        <div className="text-center mb-3">
            <ProductFormImagesList setFieldValue={setFieldValue} values={values} onDeleteImage={handleDeleteImage} />
        </div>
    );
};

export default ProductFormIamges;
